module.exports = __webpack_public_path__ + "img/lait2age.936fcb70.png";